import Vue from 'vue';
import Router from 'vue-router';

import homepage from '@/components/homepage';
import listPage from '@/components/homepage/list';
import detail from '@/components/homepage/detail';
import simpleDetail from '@/components/homepage/simpleDetail';
import goodsList from '@/components/homepage/goodsList';

Vue.use(Router);

export default new Router({
  // mode:'history',
  routes: [
    {
      path: '/',
      name: 'homepage',
      component: homepage,
        meta:{keepAlive: true}
    },
      {
          path: '/list',
          name: 'listPage',
          component: listPage,
          meta:{keepAlive: true}
      },
    {
        path: '/detail',
        name: 'detail',
        component: detail,
        meta:{keepAlive: false}
    },
    {
        path: '/s/:sku',
        name: 'simpleDetail',
        component: simpleDetail,
        meta:{keepAlive: false}
    },
      {
          path: '/goodsList',
          name: 'goodsList',
          component: goodsList,
          meta:{keepAlive: true}
      }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js